import { render, staticRenderFns } from "./ApiError.vue?vue&type=template&id=58873416&"
import script from "./ApiError.vue?vue&type=script&lang=ts&"
export * from "./ApiError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports